import { createSelector } from 'reselect';
import getGiftcardSurcharge from './getGiftcardSurcharge';

export default createSelector(
  [getGiftcardSurcharge, (_: any, value: number) => value],
  (surcharge, value) => {
    let calculatedValue = 0;
    if (surcharge?.ServiceFeeIsPercentage) {
      if (value === 0) {
        calculatedValue = 0;
      } else {
        calculatedValue = value * surcharge.ServiceFee;
      }
    } else if (surcharge) {
      calculatedValue = surcharge.ServiceFee! * 100;
    } else {
      calculatedValue = 0;
    }
    return {
      description: surcharge?.ServiceFeeDesc,
      value: calculatedValue,
    };
  },
);
